import { apiClient } from './client';

export type CommentEntityType = 'outcome' | 'output' | 'indicator' | 'activity' | 'workplan' | 'beneficiaries' | 'locations' | 'implementation' | 'risk' | 'meal' | 'budget';

export interface Comment {
  id: number;
  project_id: number;
  entity_type: string;
  entity_id: number | null;
  body: string;
  created_by: number;
  created_at: string;
  author_name: string;
}

/** Project-scoped comments - the original, real implementation. Untouched. */
export const commentsApi = {
  list: (projectId: number, entityType: CommentEntityType, entityId?: number) => {
    const params = new URLSearchParams({ projectId: String(projectId), entityType, ...(entityId ? { entityId: String(entityId) } : {}) });
    return apiClient.get<{ data: Comment[] }>(`/api/comments?${params.toString()}`);
  },
  create: (projectId: number, entityType: CommentEntityType, entityId: number | null, body: string) =>
    apiClient.post<{ data: Comment }>('/api/comments', { projectId, entityType, entityId, body }),
};

export interface GenericComment {
  id: number;
  entity_type: string;
  entity_id: number;
  body: string;
  created_by: number;
  created_at: string;
  author_name: string;
}

/**
 * Generic, project-independent comments for HR entities - a
 * genuinely separate real backend endpoint (/api/comments/:entityType/
 * :entityId, not /api/comments?projectId=...), since Project comments
 * require a real project_id and HR entities have nothing to do with
 * Projects. Deliberately NOT merged into commentsApi above to avoid
 * conflating two different real API contracts.
 */
export const genericCommentApi = {
  list: (entityType: string, entityId: number) => apiClient.get<{ data: GenericComment[] }>(`/api/comments/${entityType}/${entityId}`),
  create: (entityType: string, entityId: number, body: string) => apiClient.post<{ data: { id: number } }>(`/api/comments/${entityType}/${entityId}`, { body }),
};
